module.exports = __webpack_public_path__ + "img/头像page.2d797b42.jpg";